<template>
  <Teleport to="body">
    <div class="toast-container" aria-live="polite">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="['toast-item', `toast-${toast.type}`]"
          @click="removeToast(toast.id)"
        >
          <span class="toast-message">{{ toast.message }}</span>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script>
import { useToast } from "@/composables/useToast.js";

export default {
  name: "ToastNotification",
  setup() {
    const { toasts, removeToast } = useToast();
    return { toasts, removeToast };
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  /* Clears the 56px bottom tab bar + its platform inset (--al-tab-bar-inset,
     utilities.css). The static 64px line is the fallback for WebViews without
     calc()/var() support, which would otherwise discard the whole calc() and
     drop the offset entirely. */
  bottom: 64px;
  bottom: calc(56px + var(--al-tab-bar-inset) + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  width: 90%;
  max-width: 400px;
}

.toast-item {
  pointer-events: auto;
  padding: 12px 20px;
  border-radius: var(--al-radius-md);
  font-size: 14px;
  font-weight: 500;
  color: var(--al-white);
  cursor: pointer;
  box-shadow: var(--al-shadow-md);
  width: 100%;
  text-align: center;
}

/* al-success, al-amber, and al-info are too light for white text to clear AA
   contrast, so those three variants use ink text; al-danger holds up with
   white. */
.toast-success { background-color: var(--al-success); color: var(--al-ink-900); }
.toast-error   { background-color: var(--al-danger); }
.toast-warning { background-color: var(--al-amber); color: var(--al-ink-900); }
.toast-info    { background-color: var(--al-info); color: var(--al-ink-900); }

/* Transition */
.toast-enter-active {
  transition: all var(--al-dur-medium) var(--al-ease-enter);
}
.toast-leave-active {
  transition: all var(--al-dur-short) var(--al-ease-exit);
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

/* Motion is for orientation, not decoration. Collapse it when requested. */
@media (prefers-reduced-motion: reduce) {
  .toast-enter-active,
  .toast-leave-active {
    transition-duration: 0.01ms;
  }
}
</style>
